import React from 'react';
interface StatsCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
  color?: 'indigo' | 'green' | 'blue' | 'purple' | 'orange' | 'red';
}
export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon,
  trend,
  className = '',
  color = 'indigo'
}) => {
  const colorClasses = {
    indigo: 'bg-indigo-50 text-indigo-600 border-indigo-100',
    green: 'bg-green-50 text-green-600 border-green-100',
    blue: 'bg-blue-50 text-blue-600 border-blue-100',
    purple: 'bg-purple-50 text-purple-600 border-purple-100',
    orange: 'bg-orange-50 text-orange-600 border-orange-100',
    red: 'bg-red-50 text-red-600 border-red-100'
  };
  const trendColor = trend?.isPositive ? 'text-green-600' : 'text-red-600';
  return <div className={`bg-white rounded-xl shadow-sm border border-gray-100 p-5 hover:shadow-md transition-shadow duration-300 ${className}`} data-id="element-72">
      <div className="flex items-center justify-between" data-id="element-73">
        <div className="flex-1" data-id="element-74">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-75">{title}</h3>
          <div className="mt-2 flex items-baseline" data-id="element-76">
            <p className="text-2xl font-bold text-gray-900" data-id="element-77">{value}</p>
            {trend && <p className={`ml-2 text-xs font-medium flex items-center ${trendColor}`} data-id="element-78">
                <span data-id="element-79">
                  {trend.isPositive ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" data-id="element-80">
                      <path fillRule="evenodd" d="M12.577 4.878a.75.75 0 01.919-.53l4.78 1.281a.75.75 0 01.531.919l-1.281 4.78a.75.75 0 01-1.449-.387l.81-3.022a19.407 19.407 0 00-5.594 5.203.75.75 0 01-1.139.093L7 10.06l-4.72 4.72a.75.75 0 01-1.06-1.061l5.25-5.25a.75.75 0 011.06 0l3.074 3.073a20.923 20.923 0 015.545-4.931l-3.042-.815a.75.75 0 01-.53-.919z" clipRule="evenodd" data-id="element-81" />
                    </svg> : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" data-id="element-82">
                      <path fillRule="evenodd" d="M1.22 5.222a.75.75 0 011.06 0L7 9.942l3.768-3.769a.75.75 0 011.113.058 20.908 20.908 0 013.813 7.254l1.574-2.727a.75.75 0 011.3.75l-2.475 4.286a.75.75 0 01-.691.407h-4.126a.75.75 0 01-.122-1.485l3.449-.285a19.407 19.407 0 00-3.479-6.25L7 10.942l-4.72-4.72a.75.75 0 010-1.061z" clipRule="evenodd" data-id="element-83" />
                    </svg>}
                </span>
                {trend.value}%
              </p>}
          </div>
        </div>
        <div className={`p-3 rounded-lg ${colorClasses[color]}`} data-id="element-84">{icon}</div>
      </div>
    </div>;
};